import { Description } from "./Description";
import { Hero } from "./Hero";
import { LiveStream } from "./Livestream";
import { LatestGames } from "./LatestGames";
import { RecentGames } from "./Recentgames";
import { useMatches } from "../../hooks/useMatches";
import { useTimerFetch } from "../../hooks/useTimer";
import { useHomeStream } from "./hooks/useHomeStream";
import { PlayOffGraph } from "./PlayoffGraph";
import { RoutePageMeta } from "../../seo/RoutePageMeta";

export const Home = () => {
  const { playedMatches, upcomingMatches, playoffMatches, loading: matchesLoading } = useMatches();
  const { loading, failed, remainingSeconds, noContent } = useTimerFetch();
  const {
    matchSoon,
    nextUpcomingMatch,
    liveMatches,
    liveStreamEntries,
    streamChannel,
    streamLink,
  } = useHomeStream(upcomingMatches, remainingSeconds, loading);

  const showPlayoffs = Boolean(playoffMatches?.length);

  return (
    <>
      <RoutePageMeta page="HOME" />
      <div className="home-page">
        <Hero
          remainingSeconds={remainingSeconds}
          failed={failed}
          loading={loading}
          noContent={noContent}
          nextUpcomingMatch={nextUpcomingMatch}
          liveMatches={liveMatches}
        />
        <LiveStream
          matchSoon={matchSoon}
          /* Twitch healthcheck runs only in the 1h / live-match window (see useLivestreamSection) */
          enabled={!failed}
          streamChannel={streamChannel}
          streamLink={streamLink}
          liveStreamEntries={liveStreamEntries}
          hasLiveTaggedMatches={liveMatches.length > 0}
          visibilityPending={matchesLoading || loading}
        />
        <section className="flex flex-col h-full min-h-150 gap-4">
          <div className="flex-1 min-h-0">
            <LatestGames upcomingMatches={upcomingMatches} />
          </div>
          <div className="flex-1 min-h-0">
            <RecentGames playedMatches={playedMatches} />
          </div>
        </section>
        {showPlayoffs ? <PlayOffGraph playoffMatches={playoffMatches} /> : null}
        <Description />
      </div>
    </>
  );
};
